import { Colors } from "@/enums/Colors";
import { Box, Typography, styled } from "@mui/material";
import { useTranslation } from "react-i18next";
import FetchingQuickBooks from "../../../assets/images/fetching_quickbooks.svg";

const ImgContainer = styled(Box)(() => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  padding: ".5rem",
}));

const TextContainer = styled(Box)(() => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "left",
  gap: "1rem",
}));

const Title = styled(Typography)(() => ({
  textAlign: "left",
  fontWeight: "500",
  fontSize: "1.5rem",
  lineHeight: "1.75rem",
  color: Colors.WHITE,
}));

const BodyText = styled(Typography)(() => ({
  textAlign: "left",
  fontWeight: "500",
  fontSize: ".875rem",
  lineHeight: "1.25rem",
  color: Colors.WHITE,
}));

function ConnectingAccounting() {
  const { t } = useTranslation("integrations");

  return (
    <>
      <TextContainer>
        <Title>{t("connectingAccounting.title")}</Title>
        <BodyText>{t("connectingAccounting.description")}</BodyText>
        <BodyText>{t("connectingAccounting.timeframe")}</BodyText>
        <BodyText>{t("connectingAccounting.notification")}</BodyText>
      </TextContainer>
      <ImgContainer>
        <img src={FetchingQuickBooks.src} />
      </ImgContainer>
      <BodyText>
        {t("connectingAccounting.support.text")}{" "}
        <a href="mailto:support@lazo.us" style={{ color: Colors.WHITE }}>
          {t("connectingAccounting.support.email")}
        </a>
      </BodyText>
    </>
  );
}

export default ConnectingAccounting;
